import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { cartApi } from './api/cartapi'
import token from './state/token'
import cart from './state/cart'
import wishlist from './state/wishlist'
import { wishlistApi } from './api/wishlistapi'
import { bannerApi } from './api/bannerapi'
import theam from './state/theam'; 
import { addressApi } from './api/addressapi'
import { saveCartApi } from './api/savecartapi'

export const store = configureStore({
  reducer: {
    token:token,
    theam: theam,  

    cart:cart,
    wishlist:wishlist,
    [cartApi.reducerPath]: cartApi.reducer,
    [wishlistApi.reducerPath]: wishlistApi.reducer,
    [bannerApi.reducerPath]: bannerApi.reducer,
    [addressApi.reducerPath]: addressApi.reducer,
    [saveCartApi.reducerPath]: saveCartApi.reducer,

  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(cartApi.middleware).concat(wishlistApi.middleware).concat(bannerApi.middleware).concat(addressApi.middleware).concat(saveCartApi.middleware),
})

setupListeners(store.dispatch)